import FieldAllowedAttributeTypes from 'src/app/forms/fields/field-allowed-attribute-types.values';
import FieldAllowedValueClasses from 'src/app/forms/fields/field-allowed-value-classes.values';
import { ContactUsFormTypes, FormTypes } from 'src/app/forms/forms.enum';
import { Attribute } from 'src/app/interfaces/form-and-field.interface';

export const mockEmailFieldMetadata: (readOnly?: boolean) => Attribute = (readOnly = false) => {
  return {
    name: 'email',
    value_class_front: FieldAllowedValueClasses.EMAIL,
    min_length: 6,
    max_length: 254,
    type_attribute: FieldAllowedAttributeTypes.EMAIL,
    required: true,
    read_only: readOnly,
    label: 'Email',
    placeholder: 'Enter valid email address',
    security: true,
    scheme_name: FormTypes.CONTACT_US,
  };
};

export const mockContactUsLoggedInMetadata: Attribute[] = [
  {
    name: 'subject',
    value_class_front: FieldAllowedValueClasses.CHARACTERS,
    min_length: 1,
    max_length: 50,
    type_attribute: FieldAllowedAttributeTypes.TEXT,
    required: true,
    read_only: false,
    label: 'Subject',
    placeholder: 'Enter message subject',
    security: false,
    scheme_name: FormTypes.CONTACT_US,
  },
  {
    name: 'message',
    value_class_front: FieldAllowedValueClasses.TEXTAREA_FULL,
    min_length: 1,
    max_length: 1000,
    type_attribute: FieldAllowedAttributeTypes.TEXTAREA,
    required: true,
    read_only: false,
    label: 'Message',
    placeholder: 'Enter message here',
    security: false,
    scheme_name: FormTypes.CONTACT_US,
  },
];

export const contactUsMetadata: { [key in ContactUsFormTypes]: () => Attribute[] } = {
  contact_us_logged_in: () => mockContactUsLoggedInMetadata,
};
